import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { DateHandlingService } from '../../../services/date-handling.service';
import { MaskService } from '../../../services/mask.service';
import { DateTime } from 'luxon';
import { ProductStats } from '../../../models/dashboard-models';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PercentPipe } from '@angular/common';

@Component({
  selector: 'app-unit-product-stats',
  templateUrl: './unitProductStats.component.html',
  styleUrls: ['./unitProductStats.component.scss'],
  imports: [
    NgxLoadingModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    PercentPipe,
  ],
  providers: [],
})
export class UnitProductStatsComponent implements OnChanges {
  private dateSvc = inject(DateHandlingService);
  private dbs = inject(DashboardService);
  private ss = inject(SessionStorageService);
  private router = inject(Router);
  mask = inject(MaskService);

  @Input() solutionId;
  @Input() start;
  @Input() end;
  @Input() selectedUnit;
  loading = false;
  app = this.ss.get('currentApp');
  data;
  dollarMask = this.mask.dollarMaskSpecs();

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.solutionId && changes.solutionId.previousValue !== undefined) ||
      (changes.end && changes.end.previousValue === null) ||
      changes.selectedUnit
    ) {
      this.updateData();
    }
  }

  updateData() {
    this.loading = true;

    this.dbs
      .getUnitProductCaseStats(
        this.selectedUnit,
        this.dateSvc.toUseableString(this.start, 'start'),
        this.dateSvc.toUseableString(this.end, 'end'),
        this.solutionId
      )
      .subscribe(
        (x: {
          overall?: ProductStats;
          productTypeProducts?: ProductStats[];
          productNameProducts?: ProductStats[];
        }) => {
          this.data = x;
          this.loading = false;
        }
      );
  }

  goToProfile(ev, id) {
    this.router.navigate([`/li/questionnaire/${id}`]);
  }

  launchCe(launchCase) {
    // Normalizes a DateTime, Date, or ISO string into a Luxon DateTime
    const toDateTime = value => {
      if (DateTime.isDateTime(value)) {
        return value;
      }
      if (value instanceof Date) {
        return DateTime.fromJSDate(value);
      }
      return DateTime.fromISO(value);
    };
    const startVal = toDateTime(this.start).startOf('day').toUTC().toISO();
    const endVal = toDateTime(this.end).endOf('day').toUTC().toISO();
    const saveFilters = {
      filters: [
        {
          field: 'unitId',
          operator: 'equal',
          value: this.selectedUnit,
        },
        {
          field: 'solutionId',
          operator: 'equal',
          value: this.solutionId,
        },
        {
          field: 'savedTime',
          operator: 'start',
          value: startVal,
        },
        {
          field: 'savedTime',
          operator: 'end',
          value: endVal,
        },
        {
          field: 'group',
          operator: 'equal',
          value: 'products',
        },
      ],
      group: 'products',
    };

    if (launchCase.productType) {
      saveFilters.filters.push({
        field: 'productType',
        operator: 'equal',
        value: [launchCase.productType],
      });
    }

    if (launchCase.productName) {
      saveFilters.filters.push({
        field: 'productName',
        operator: 'equal',
        value: [launchCase.productName],
      });
    }

    this.ss.set('CaseExplorerFilters', saveFilters);

    this.router.navigate([`/case-explorer`]);
  }

  checkOverall(): boolean {
    return !!(
      this.data.overall?.total &&
      this.data.overall?.totalAmount &&
      this.data.overall?.averageAmount &&
      this.data.overall?.positive &&
      this.data.overall?.neutral &&
      this.data.overall?.negative
    );
  }
}
